var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpFrame3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 981 981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#10283a;}.cls-2{fill:#173856;}.cls-3{fill:#fbbcaa;}.cls-4{fill:#20456e;}.cls-5{fill:#639;}.cls-6{fill:#442114;}.cls-7{fill:#2b120a;}.cls-8{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "frame 3 F") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "haut_3_f",
    "data-name": "haut 3 f"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "471 895 471 965 404 965 404 891 471 895"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1008,1248l7,241c-2.15-53.29,96.85-57.29,99-4l-16-233Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1114,1485v79c0,35.19-99,35.19-99,0v-75C1012.85,1435.76,1111.85,1431.76,1114,1485Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M917,1252v241c0,34.27,80,34.27,80,0l13.67-153.1-2.42-87.9Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1147,1166c-5.12-20.85-62.12-6.85-57,14,0,0,3,38,37,32S1147,1166,1147,1166Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1082,1019.54c22.58.39,40.5,9.34,49,35.46l22,107c0,36-68,41-68,14Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1098.18,1252.5v-203s0-50-90.59-50-90.59,40-90.59,40v213Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 917,
    y: 1244,
    width: 181,
    height: 9,
    transform: "translate(1498 1886) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M815.59,836.19C829.59,816,839,832.4,839,830.5a169,169,0,0,1,168.59-169h.41a169,169,0,0,1,168.59,169c0,1.9,9.41-14.5,23.41,5.69,7.72,11.13,8.89,57.77-9,76.81-14.55,15.49-33,24-45.38,15A168.78,168.78,0,0,1,1008,999.49h-.41A168.78,168.78,0,0,1,870,928c-12.38,9-30.83.45-45.38-15C806.7,894,807.87,847.32,815.59,836.19Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1008.25,647.41c0-2.87-.25-19.41-.25-21.41,34,0,81,4,90.86,38.25,46.49,20.4,84,60.11,92.23,123.75,1.91,42-5.09,39-15.09,42-8.21,33.38-14.41,77-32,100a223.08,223.08,0,0,1-24.17,27A169.09,169.09,0,0,1,1076,987c-31.06,15-54,14-67.75,12.8Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1099,664c7.31,127.57-22.78,202.9-85,215C1069.05,811.1,1098.87,739.65,1099,664Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1006,1000c27.21-1,45.67,2.64,60,9.5-13.68,11-34.89,10.5-60,10.5s-46.32.48-60-10.5C960.33,1002.64,978.79,999,1006,1000Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M932,1016.54c-22.58.39-40.5,9.34-49,35.46l-22,107c0,36,68,41,68,14Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M867,1163c5.12-20.85,62.12-6.85,57,14,0,0-3,38-37,32S867,1163,867,1163Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1009,647.41c0-2.87.25-19.41.25-21.41-34,0-81,4-90.87,38.25-46.49,20.4-84,60.11-92.22,123.75-1.91,42,5.09,39,15.09,42,8.21,33.38,14.4,77,32,100a222.24,222.24,0,0,0,24.17,27,168.92,168.92,0,0,0,43.83,30c31.06,15,54,14,67.75,12.8Z",
    transform: "translate(-517 -611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M918.08,664c-7.31,127.57,22.78,202.9,85,215C948,811.1,918.21,739.65,918.08,664Z",
    transform: "translate(-517 -611)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "cadre_invisible",
    "data-name": "cadre invisible"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    width: 981,
    height: 981
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpFrame3);
export default __webpack_public_path__ + "static/media/up_frame_3.f333bffa18268f8eb9df958f8de2feb6.svg";
export { ForwardRef as ReactComponent };